<template>
    <body class="app sidebar-mini ltr login-img">
        <div>
            <!-- <div id="global-loader">
                <img src="/images/loader.svg" class="loader-img" alt="Loader">
            </div> -->
    
            <div class="page">
                <div class="">
                    <!-- Theme-Layout -->
                    <div class="container-login100">
                        <div class="wrap-login100 p-8">
                            <ValidationObserver tag="form" @submit.prevent="authenticate" v-slot="{ invalid }" ref="observer" class="login100-form validate-form">
                                <div class="text-center">
                                    <img src="/img/logo_asin.png" class="header-brand-img" height="50" alt="LOGO ASIN">
                                </div>
                                <div class="mt-5">
                                    <span class="login100-form-title pb-5 fw-bold">
                                        GESPRO DEV
                                    </span>
                                </div>
                                <div class="panel panel-primary">
                                    <div class="tab-menu-heading text-center">
                                        <div class="tabs-menu1 fw-semibold">
                                            Definissez votre mot de passe
                                        </div>
                                    </div>
                                    <div class="panel-body tabs-menu-body pt-5 px-5">
                                        <div class="tab-content">
                                            <div class="tab-pane active" id="tab5">
                                                <ValidationProvider tag="div" name="newPassword" rules="required|min:8" class="form-group mb-3" v-slot="{ errors }"  vid="newPassword">
                                                    <label>Mot de passe</label>
                                                    <div class="wrap-input100 validate-input input-group">
                                                        <a href="javascript:void(0)" @click.prevent="show1 = !show1" class="input-group-text bg-white text-muted">
                                                            <i class="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                                                        </a>
                                                        <input class="input100 border-start-0 form-control ms-0" :type="show1 ? 'text' : 'password'" name="newPassword" v-model="payload.newPassword" placeholder="***********" autofocus>
                                                    </div>
                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                </ValidationProvider>
                                                <ValidationProvider tag="div" name="repeatPassword" rules="required|confirmed:newPassword" class="form-group" v-slot="{ errors }">
                                                    <label>Repetez le mot de passe</label>
                                                    <div class="wrap-input100 validate-input input-group" id="Password-toggle">
                                                        <a href="javascript:void(0)" @click.prevent="show2 = !show2" class="input-group-text bg-white text-muted">
                                                            <i class="zmdi zmdi-eye text-muted" aria-hidden="true"></i>
                                                        </a>
                                                        <input class="input100 border-start-0 form-control ms-0" :type="show2 ? 'text' : 'password'" name="repeatPassword" v-model="payload.repeatPassword" id="repeatPassword" placeholder="**********">
                                                    </div>
                                                    <small class="form-text text-danger">{{ errors[0] }}</small>
                                                </ValidationProvider>
                                                
                                                <div class="container-login100-form-btn">
                                                    <button class="login100-form-btn btn-primary" :disabled="invalid">
                                                            <span class="fe fe-unlock"></span> &nbsp;<span v-if="!loading">Enregistrer</span>
                                                            <span v-else-if="error">{{ error }}</span>
                                                            <span v-else>Enregistrement en cours</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ValidationObserver>
                        </div>
                    </div>
                    <!-- CONTAINER CLOSED -->
                </div>
            </div>
        </div>
    </body>
    </template>
    
    <script>
    import { mapGetters, mapActions } from "vuex";
    //import axios from "axios";
    export default {
        name: "Connexion",
        data() {
            return {
                loading: false, payload:{username: "", password: ""}, error: "", show1: false, show2: false, token: ""
            }
        },
        methods: {
            authenticate(){
                this.loading = true;
                this.$loading(true);
                this.error = null;
                if(this.payload){
                    this.payload.token = this.token;
                    console.log(this.payload);
                    this.$http.post('/users/actions/resetPassword/apply', this.payload)
                    //this.$store.dispatch('user/login', this.payload)
                        .then(({data}) => {
                            if (data.status) {
                            swal('Information!', data.message, 'success');
                        } else {
                            swal('Information!', data.message, 'error');
                        }
                            this.$router.push('/');
                            this.loading = false;                    
                        })
                        .catch(err => {
                            console.error(err);
                            this.error = err.response ? err.response.data.message : 'Une erreur est survenue';
                            swal('Erreur!', this.error, 'error');
                        })
                        .finally(() => {this.loading = false; this.$loading(false);});
                }
            }
        },
        created() {
            this.token = this.$route.query.token;
        },
    }
    </script>
    
    <style>
    
    </style>